import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

import { TOOLTIP_DEFAULT_DELAY } from '@flowx/designer/modules/core/dictionary/constants'
import { WorkspaceEnvTypeTagComponent } from '@flowx/designer/modules/workspaces/shared/workspace-env-type-tag/workspace-env-type-tag.component'
import { ApplicationType } from '@flowx/designer/shared/entities/application.entity'

import { ExtendedNotification } from '../notifications.model'

/** Where the event happened: the workspace type, the workspace, and the project or library. */
@Component({
  selector: 'flx-notification-context',
  imports: [TooltipModule, WorkspaceEnvTypeTagComponent],
  templateUrl: './notification-context.component.html',
  host: {
    class: 'flex items-center min-w-0 gap-2',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxNotificationContextComponent {
  TOOLTIP_DEFAULT_DELAY = TOOLTIP_DEFAULT_DELAY

  notification = input.required<ExtendedNotification>()

  applicationIcon = computed(() =>
    this.notification().appType === ApplicationType.LIB ? 'ph ph-books' : 'ph ph-folder-simple'
  )
}
